import React, { forwardRef } from 'react';
import { PCC_ACTION_URL, PCC_WINDOW_NAME } from '../helper/PccHelper';

interface PccRequestFormProps {
  onRequest: () => void;
  className?: string;
  buttonClassName?: string;
  buttonLabel?: string;
  disabled?: boolean;
}

const PccRequestForm = forwardRef<HTMLFormElement, PccRequestFormProps>(function PccRequestForm(
  { onRequest, className, buttonClassName, buttonLabel = '실명인증', disabled = false }, ref) {
  return (
    <form ref={ref} id="reqPCCForm" name="reqPCCForm" method="post"
          action={PCC_ACTION_URL} target={PCC_WINDOW_NAME} className={className}
          onSubmit={(e) => e.preventDefault()}>
      <input type="hidden" name="crypto_token_id" defaultValue="" />
      <input type="hidden" name="integrity_value" defaultValue="" />
      <input type="hidden" name="reqInfo" defaultValue="" />
      <input type="hidden" name="verSion" defaultValue="3" />
      <button type="button" className={buttonClassName} disabled={disabled} onClick={onRequest}>{buttonLabel}</button>
    </form>
  );
});

export default PccRequestForm;
